import { MerchantAccount } from "client/lib/apt-merchant";

export const merchantAccountInitialState: MerchantAccount = {
  account: undefined,
  bsb: undefined,
  bsb2: undefined,
  cashPayChannel: false,
  cashPayOnboardingStatus: undefined,
  contactlessPayment: undefined,
  customerSupportEmail: undefined,
  customerSupportPhone: undefined,
  customerSupportWebsite: undefined,
  inStoreDirectDebitAuthorized: false,
  inStoreTrainingComplete: false,
  locations: undefined,
  merchantId: undefined,
  mlsProspectRef: undefined,
  onboardingGroup: undefined,
  onboardingLink: undefined,
  onboardingStatus: undefined,
  opportunityOwnerEmail: undefined,
  owners: undefined,
  ownerControls: [
    { requireId: false, requireCertifiedId: false },
    { requireId: false, requireCertifiedId: false },
    { requireId: false, requireCertifiedId: false },
    { requireId: false, requireCertifiedId: false },
    { requireId: false, requireCertifiedId: false },
  ],
  registrationNumber: undefined,
  requireInsurance: false,
  requireTrustDeed: false,
  routing: undefined,
  selfFulfillment: false,
  selfServeInStore: false,
  sfProspectId: undefined,
  totalAnnualSalesInStore: undefined,
  trustDeedRequired: false,
  website: undefined,
};
